export enum AppConnectionStatuses {
  CONNECTION_LOST = 'connection_lost',
  DISCONNECTED = 'disconnected',
  NEEDS_REAUTHORIZATION = 'needs_reauthorization',
  NEW_FEATURES_AVAILABLE = 'new_features_available',
  NO_STATUS_AVAILABLE = 'no_status_available',
  OK = 'ok',
  SYNC_ERROR = 'sync_error',
  SUNSET = 'sunset',
  UPCOMING_SUNSET = 'upcoming_sunset',
  UPDATE_AVAILABLE = 'update_available',
  UPGRADE_AVAILABLE = 'upgrade_available',
}
